
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';
import ContactFeatureGrid from './ContactFeature';

interface HeroContentProps {
  title: string;
  subtitle: string;
  subheading: string;
}

const HeroContent: React.FC<HeroContentProps> = ({ title, subtitle, subheading }) => {
  const navigate = useNavigate();
  const { currentLanguage } = useLanguage();
  
  // Define the contact button path based on language
  const handleContactClick = () => {
    const contactPath = `/${currentLanguage}/${
      currentLanguage === 'de' ? 'kontakt' : 
      currentLanguage === 'en' ? 'contact' : 
      currentLanguage === 'fr' ? 'contact' : 
      'contatto'
    }`;
    navigate(contactPath);
  };
  
  // Get accessible button text based on language
  const getButtonText = () => {
    switch (currentLanguage) {
      case 'de': return 'Kontaktieren Sie uns';
      case 'en': return 'Contact Us';
      case 'fr': return 'Contactez-nous';
      case 'it': return 'Contattaci';
      default: return 'Contact Us';
    }
  };
  
  return (
    <div className="mt-8 md:mt-16 bg-black/40 backdrop-blur-md p-4 md:p-6 rounded-xl border border-purple-500/20 max-w-4xl mx-auto">
      <h1 id="hero-heading" className="text-2xl md:text-3xl font-bold text-white mb-2">
        {title}
      </h1>
      <h2 className="text-xl md:text-2xl font-bold text-white mb-4 md:mb-6">
        {subtitle}
      </h2>
      
      <ContactFeatureGrid />
      
      <div className="mt-6 md:mt-8">
        <Button
          onClick={handleContactClick}
          className="bg-gradient-to-r from-purple-600 to-purple-800 hover:from-purple-700 hover:to-purple-900 text-white px-6 md:px-8 py-4 md:py-5 rounded-lg shadow-lg group"
          aria-label={getButtonText()}
          data-seo-button="contact"
        >
          {getButtonText()}
          <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" aria-hidden="true" />
        </Button>
      </div>
      
      <p className="mt-4 text-gray-200 text-xs md:text-sm italic">
        {subheading}
      </p>
    </div>
  );
};

export default HeroContent;
